<template>
    <div class="apprentice-simple-card">
        <div class="text-muted">
            {{ $t('group.settings.edit_page_rights') }}
            <p>
                {{ $t('group.settings.new_page_rights_comma_separated') }}
            </p>
        </div>

        <b-form-group
            :label="$t('group.settings.pages')"
            label-for="page-access-rights-input">
            <b-form-input
                id="page-access-rights-input"
                v-model="rights"
                required
                :placeholder="$t('group.settings.enter_page_numbers_seperated_by_commas')">
            </b-form-input>
        </b-form-group>

        <b-button
            class="btn-save"
            @click="setPageRights"
            variant="primary"
            >{{ $t('common.save') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-pagerights-component',
    props: ['groupIn'],
    data() {
        return {
            rights: '',
        };
    },
    methods: {
        setPageRights() {
            this.alert.saving();

            const data = {
                rights: this.rights,
            };

            this.axios.post(this.routes.groupSetPageRights(this.groupIn.id), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
